import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { Button, Checkbox, Dropdown, IconButton } from "rsuite";
import { LoadingContext } from "../contexts/LoadingContext";
import { SearchContext } from "../contexts/SearchContext";
import {
  createMerchant,
  deleteMerchant,
  getMerchants,
  updateMerchant,
} from "../services/sales/MerchantApi";
import { errorToast } from "../utils/helper-ui";
import { PaginationResponse } from "../objects/pagination";
import { getPagination } from "../utils/helper";
import { Merchant } from "../models/sales/merchant";
import { Table, Pagination } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { BsEye, BsTrash3 } from "react-icons/bs";
import MerchantForm from "../components/features/sales/MerchantForm";
import { useNavigate } from "react-router-dom";
const { Column, HeaderCell, Cell } = Table;
interface MerchantPageProps {}

const MerchantPage: FC<MerchantPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [merchants, setMerchants] = useState<Merchant[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState<Merchant>();
  const [status, setStatus] = useState("ALL");
  const nav = useNavigate();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === merchants.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < merchants.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? merchants.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size, status]);

  useEffect(() => {
    setPage(1);
  }, [status]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getMerchants({ page, size, search, status });
      const resJson = await res.json();
      //   console.log(data);
      setMerchants((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const removeMerchant = async (merchant: Merchant) => {
    try {
      setIsLoading(true);
      if (
        window.confirm(
          `Are you sure you want to delete merchant with name ${merchant.name}?`
        )
      ) {
        await deleteMerchant(merchant.id!);
        fetchData();
      }
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const saveMerchant = async (merchant: Merchant) => {
    try {
      setIsLoading(true);
      if (selectedMerchant) {
        await updateMerchant(selectedMerchant.id!, merchant);
      } else {
        await createMerchant(merchant);
      }
      setModalFormOpen(false);
      setSelectedMerchant(undefined);
      fetchData();
      setMerchants([]);
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Merchant</h1>
      {/* button */}
      <div className=" flex flex-row gap-2">
        <Dropdown
          appearance="primary"
          color={
            status === "ALL"
              ? "blue"
              : status === "ACTIVE"
              ? "green"
              : status === "PENDING"
              ? "orange"
              : status === "REJECTED"
              ? "red"
              : "violet"
          }
          size="md"
          title={status}
        >
          <Dropdown.Item onClick={() => {setMerchants([]); setStatus("ALL")}}>ALL</Dropdown.Item>
          <Dropdown.Item onClick={() => {setMerchants([]); setStatus("ACTIVE")}}>
            ACTIVE
          </Dropdown.Item>
          <Dropdown.Item onClick={() => {setMerchants([]); setStatus("PENDING")}}>
            PENDING
          </Dropdown.Item>
          <Dropdown.Item onClick={() => {setMerchants([]); setStatus("SUSPENDED")}}>
            SUSPENDED
          </Dropdown.Item>
          <Dropdown.Item onClick={() => {setMerchants([]); setStatus("REJECTED")}}>
            REJECTED
          </Dropdown.Item>
        </Dropdown>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Merchant
        </IconButton>
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50" style={{ width: 100 }}>
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50" style={{ width: 300 }}>Address</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Phone</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Status</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Latitude
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Longitude
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Company</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {merchants.map((rowData, i) => (
              <tr key={i} className="hover:bg-gray-100">
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={rowData.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === rowData.id)}
                  />
                  {i + 1}
                </td>

                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold "
                    onClick={() => {
                      // setSelectedMerchant(rowData as Merchant);
                      // setModalFormOpen(true);
                      nav(`/merchant/${rowData.id}`);
                    }}
                  >
                    {rowData.name}
                  </div>
                </td>
                <td className="px-4 py-2 border">{rowData.address}</td>
                <td className="px-4 py-2 border">{rowData.phone}</td>
                <td className="px-4 py-2 border">
                  {rowData?.status?.toLowerCase() === "active" && (
                    <div className="bg-green-500 text-white rounded px-2 py-1 text-center">
                      Active
                    </div>
                  )}
                  {rowData?.status?.toLowerCase() === "pending" && (
                    <div className="bg-orange-500 text-white rounded px-2 py-1 text-center">
                      Pending
                    </div>
                  )}
                  {rowData?.status?.toLowerCase() === "suspended" && (
                    <div className="bg-violet-500 text-white rounded px-2 py-1 text-center">
                      Suspended
                    </div>
                  )}
                  {rowData?.status?.toLowerCase() === "rejected" && (
                    <div className="bg-red-500 text-white rounded px-2 py-1 text-center">
                      Rejected
                    </div>
                  )}
                </td>
                <td className="px-4 py-2 border">{rowData.latitude}</td>
                <td className="px-4 py-2 border">{rowData.longitude}</td>
                <td className="px-4 py-2 border">{rowData.company?.name}</td>
                <td className="px-4 py-2 border">
                  <div className="flex flex-row gap-2 cursor-pointer">
                    <BsEye
                      className="text-blue-500 hover:text-blue-800"
                      size={16}
                      onClick={() => {
                        nav(`/merchant/${rowData.id}`);
                      }}
                    />
                    <BsTrash3
                      className="text-red-500 hover:text-red-800"
                      size={16}
                      onClick={() => removeMerchant(rowData as Merchant)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={merchants} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size + merchants.indexOf(rowData as Merchant) + 1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  // setSelectedMerchant(rowData as Merchant);
                  // setModalFormOpen(true);
                  nav(`/merchant/${rowData.id}`);
                }}
              >
                {rowData.name}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Address</HeaderCell>
          <Cell dataKey="address" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Phone</HeaderCell>
          <Cell dataKey="phone" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Status</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {rowData.status.toLowerCase() === "active" && (
                  <div className="bg-green-500 text-white rounded px-2 py-1 text-center">
                    Active
                  </div>
                )}
                {rowData.status.toLowerCase() === "pending" && (
                  <div className="bg-orange-500 text-white rounded px-2 py-1 text-center">
                    Pending
                  </div>
                )}
                {rowData.status.toLowerCase() === "suspended" && (
                  <div className="bg-violet-500 text-white rounded px-2 py-1 text-center">
                    Suspended
                  </div>
                )}
                {rowData.status.toLowerCase() === "rejected" && (
                  <div className="bg-red-500 text-white rounded px-2 py-1 text-center">
                    Rejected
                  </div>
                )}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Latitude</HeaderCell>
          <Cell dataKey="latitude" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Longitude</HeaderCell>
          <Cell dataKey="longitude" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Company</HeaderCell>
          <Cell>{(rowData) => <div>{rowData.company?.name}</div>}</Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <div className="flex flex-row gap-2 cursor-pointer">
                <BsEye
                  className="text-blue-500 hover:text-blue-800"
                  size={16}
                  onClick={() => {
                    nav(`/merchant/${rowData.id}`);
                  }}
                />
                <BsTrash3
                  className="text-red-500 hover:text-red-800"
                  size={16}
                  onClick={() => removeMerchant(rowData as Merchant)}
                />
              </div>
            )}
          </Cell>
        </Column>
      </Table> */}
      {/* <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
      <MerchantForm
        merchant={selectedMerchant}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedMerchant(undefined);
        }}
        onSubmit={saveMerchant}
      />
    </MainLayout>
  );
};
export default MerchantPage;
